<template>
  <div class="ServiceArea">
    <ComTitlte titleEn="SERVICE AREA" titleZh="服务范围"></ComTitlte>
    <div class="ServiceBox ServiceBox1">
      <div class="b_title">1.职称评审</div>
      <div class="s_list">
        <div class="s_item">
          <div class="item_lable">正高级工程师</div>
          <div class="item_value">
            广州市工程系列石油和化工专业正高级职称评审委员会
          </div>
        </div>
        <div class="s_item">
          <div class="item_lable">工程师</div>
          <div class="item_value">
            广州市工程系列橡胶和化工专业中级职称评审委员会
          </div>
        </div>
        <div class="s_item">
          <div class="item_lable">高级工程师</div>
          <div class="item_value">
            广州市工程系列橡胶和化工专业高级职称评审委员会
          </div>
        </div>
        <div class="s_item">
          <div class="item_lable">初级工程师</div>
          <div class="item_value">
            广州市工程系列石油和化工专业初级职称评审委员会
          </div>
        </div>
      </div>
    </div>
    <div class="ServiceBox ServiceBox2">
      <div class="b_title">2.人才培训</div>
      <div class="s_list">
        <div class="s_item">
          <img src="@/assets/img/company/c_img_1.png" alt="..." />
          <div class="item_lable">安全生产知识</div>
          <div class="item_value">
            企业负责人；安全管理人员；<br />班组长；从业人员。
          </div>
        </div>
        <div class="s_item">
          <img src="@/assets/img/company/c_img_2.png" alt="..." />
          <div class="item_lable">企业管理高级研修</div>
          <div class="item_value">
            领导力；战略赋能；<br />
            高端总裁系列等。
          </div>
        </div>
        <div class="s_item">
          <img src="@/assets/img/company/c_img_3.png" alt="..." />
          <div class="item_lable">关键岗位能力提升</div>
          <div class="item_value">
            技能和高技能人才（钳工、电工、总控工、 仪表工
            、应急救援员、检验员、仓管员等）。
          </div>
        </div>
        <div class="s_item">
          <img src="@/assets/img/company/c_img_4.png" alt="..." />
          <div class="item_lable">素质素养相关能力</div>
          <div class="item_value">
            有效沟通；办公室技能；论文、公文写作；
            项目管理；团队建设；劳动关系等。
          </div>
        </div>
      </div>
    </div>
    <div class="ServiceBox ServiceBox3">
      <div class="b_title">3.专项服务—专业委员会</div>
      <div class="cont_service">
        <div class="cont_left">
          <div class="c_row">
            <span>01.安全生产专业委员会</span>
            <span>02.标准化专业委员会</span>
            <span>03.职业能力建设专业委员会</span>
          </div>
          <div class="c_row c_row2">
            <div class="r_lable">服务：</div>
            <div class="r_value">
              协调团体标准编制；岗位能力标准编制；企业技能人才定级评价方案编写；安全隐患排查与整改措施制定；应急救援预案编制；企业管理咨询。提供定制化一对一服务。
            </div>
          </div>
        </div>
        <div class="cont_right">
          <img src="../../../assets/img/company/c_img_5.png" alt="..." />
        </div>
      </div>
    </div>
    <div class="ServiceBox ServiceBox4">
      <div class="b_title">4.行业竞赛</div>
      <div class="cont_service">
        <b>服务：</b>
        结合人力资源和社会保障部门、工会和行业鉴定中心的工作安排，举办
        行业竞赛，通过竞赛选拔行业技术能手，培养工匠精神。
      </div>
    </div>
    <div class="ServiceBox ServiceBox4">
      <div class="b_title">5.政策宣讲</div>
      <div class="cont_service">
        <b>服务：</b
        >专业技术人员职称评审、劳动关系管理、安全和环保政策法规、技能
        人才培养、知识产权、经济形势和产业发展政策。
      </div>
    </div>
    <div class="ServiceBox ServiceBox4">
      <div class="b_title">6.标准规范</div>
      <div class="cont_service">
        <b>服务：</b>参与制定有关行业标准、团体标准，建立行业规范。
      </div>
    </div>
    <div class="ServiceBox ServiceBox4">
      <div class="b_title">7.促进公平竞争</div>
      <div class="cont_service">
        <b>服务：</b>
        加强会员的行业自律，促进会员诚信经营，维护会员的行业公平竞争。
      </div>
    </div>
  </div>
</template>

<script>
import ComTitlte from "@/components/common/comTitle";
export default {
  name: "ServiceArea",
  components: { ComTitlte },
};
</script>

<style lang="scss" scoped>
.ServiceArea {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  flex-direction: row;
  position: relative;
  .ServiceBox {
    position: relative;
    .b_title {
      font-size: 18px;
      font-weight: bolder;
      line-height: 30px;
      color: #333333;
      padding: 20px 0 20px 16px;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 10px;
        height: 15px;
        background: url("../../../assets/img/company/icon_title.png") center
          no-repeat;
        background-size: contain;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translate(0, -50%);
      }
    }
  }
  //   职称评审
  .ServiceBox1 {
    .s_list {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      flex-direction: row;
      .s_item {
        display: flex;
        width: 560px;
        height: 40px;
        margin-bottom: 20px;
        .item_lable {
          width: 128px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          background-color: #f5f9ff;
          border: solid 1px #e5e5e5;
          font-size: 16px;
          color: #333333;
          box-sizing: border-box;
        }
        .item_value {
          flex: 1;
          box-sizing: border-box;
          padding: 0 0 0 20px;
          font-size: 16px;
          line-height: 40px;
          color: #333333;
          border: solid 1px #e5e5e5;
          border-left: none;
        }
      }
    }
  }
  // 人才培训
  .ServiceBox2 {
    width: 100%;
    .s_list {
      display: flex;
      justify-content: space-between;
      .s_item {
        width: 272px;
        border: solid 1px #e5e5e5;
        border-top: none;
        text-align: center;
        .item_lable {
          height: 40px;
          line-height: 40px;
          font-size: 18px;
          color: #333333;
        }
        .item_value {
          margin: 0 auto;
          box-sizing: border-box;
          padding: 0 20px 20px 20px;
          font-size: 14px;
          line-height: 30px;
          color: #333333;
        }
      }
    }
  }
  // 专项服务—专业委员会
  .ServiceBox3 {
    .cont_service {
      display: flex;
      position: relative;
      .cont_left {
        flex: 1;
        box-sizing: border-box;
        padding: 20px;
        background-color: #f5f9ff;
        .c_row {
          display: flex;
          justify-content: space-between;
          &.c_row2 {
            margin: 20px 0 0 0;
          }
          span {
            font-size: 16px;
            font-weight: bold;
            line-height: 30px;
            color: #333333;
          }
          .r_lable {
            flex-shrink: 0;
            font-size: 16px;
            font-weight: bold;
            line-height: 30px;
            color: #333333;
          }
          .r_value {
            font-size: 16px;
            line-height: 30px;
            color: #333333;
            text-align: justify;
          }
        }
      }
      .cont_right {
        width: 520px;
        // img {
        // }
      }
    }
  }
  .ServiceBox4 {
    width: 580px;
    .cont_service {
      padding: 20px 14px 20px 16px;
      background-color: #f5f9ff;
      font-size: 16px;
      line-height: 30px;
      color: #333333;
    }
  }
}
</style>
